module.exports = __webpack_public_path__ + "img/107064.aa69b9ca.png";